import { render, staticRenderFns } from "./AppMain.vue?vue&type=template&id=44ea7886&scoped=true&"
import script from "./AppMain.vue?vue&type=script&lang=js&"
export * from "./AppMain.vue?vue&type=script&lang=js&"
import style0 from "./AppMain.vue?vue&type=style&index=0&id=44ea7886&lang=less&scoped=true&"
import style1 from "./AppMain.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44ea7886",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\YrtDev\\wms\\wms-site\\main\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44ea7886')) {
      api.createRecord('44ea7886', component.options)
    } else {
      api.reload('44ea7886', component.options)
    }
    module.hot.accept("./AppMain.vue?vue&type=template&id=44ea7886&scoped=true&", function () {
      api.rerender('44ea7886', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Layout/components/AppMain.vue"
export default component.exports